import { CustomModal } from "@/components/custom-modal";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Separator } from "@/components/ui/separator";
import { cn } from "@/lib/utils";
import { VscEye } from "react-icons/vsc";
import Reject from "../common/Reject";
import Approval from "../common/Approval";
import { formattedDate, formattedTransactionDate } from "@/lib/helper";

const General = (data: unknown) => {
  return (
    <div className="flex flex-col gap-10 justify-center max-w-[60rem] mx-auto">
      <div className="grid grid-cols-2">
        <div className="flex flex-col gap-1">
          <h3 className="text-lg text-primary-3">Personal Details</h3>
          <p className="text-gray-80 text-sm lg:w-[300px]">
            The personal details of this user are found here
          </p>
        </div>
        <div className="grid grid-cols-2 gap-5">
          <div className="flex flex-col w-full items-start gap-1.5 border-[1px] rounded-[10px] px-4 py-2 h-14 border-input-border bg-off-white-1">
            <Label className="text-xs text-gray-70">First Name</Label>
            <Input
              type="text"
              defaultValue={data?.data?.firstName}
              disabled
              className="w-full h-6 px-0 py-0 text-sm bg-transparent border-none outline-none placeholder:text-sm placeholder:font-medium ring-transparent focus-visible:ring-transparent focus:border-none text-gray-dark capitalize"
            />
          </div>
          <div className="flex flex-col w-full items-start gap-1.5 border-[1px] rounded-[10px] px-4 py-2 h-14 border-input-border bg-off-white-1">
            <Label className="text-xs text-gray-70">Last Name</Label>
            <Input
              type="text"
              value={data?.data?.lastName}
              disabled
              className="w-full h-6 px-0 py-0 text-sm bg-transparent border-none outline-none placeholder:text-sm placeholder:font-medium ring-transparent focus-visible:ring-transparent focus:border-none text-gray-dark capitalize"
            />
          </div>
          <div className="flex flex-col w-full items-start gap-1.5 border-[1px] rounded-[10px] px-4 py-2 h-14 border-input-border bg-off-white-1">
            <Label className="text-xs text-gray-70">Email Address</Label>
            <Input
              type="text"
              value={data?.data?.email}
              disabled
              className="w-full h-6 px-0 py-0 text-sm bg-transparent border-none outline-none placeholder:text-sm placeholder:font-medium ring-transparent focus-visible:ring-transparent focus:border-none text-gray-dark"
            />
          </div>
          <div className="flex flex-col w-full items-start gap-1.5 border-[1px] rounded-[10px] px-4 py-2 h-14 border-input-border bg-off-white-1">
            <Label className="text-xs text-gray-70">Phone Number</Label>
            <Input
              type="text"
              value={data?.data?.phone}
              disabled
              className="w-full h-6 px-0 py-0 text-sm bg-transparent border-none outline-none placeholder:text-sm placeholder:font-medium ring-transparent focus-visible:ring-transparent focus:border-none text-gray-dark"
            />
          </div>
          <div className="flex flex-col w-full items-start gap-1.5 border-[1px] rounded-[10px] px-4 py-2 h-14 border-input-border bg-off-white-1">
            <Label className="text-xs text-gray-70">Username</Label>
            <Input
              type="text"
              value={data?.data?.username}
              disabled
              className="w-full h-6 px-0 py-0 text-sm bg-transparent border-none outline-none placeholder:text-sm placeholder:font-medium ring-transparent focus-visible:ring-transparent focus:border-none text-gray-dark"
            />
          </div>
          <div className="flex flex-col w-full items-start gap-1.5 border-[1px] rounded-[10px] px-4 py-2 h-14 border-input-border bg-off-white-1">
            <Label className="text-xs text-gray-70">Sign up date</Label>
            <Input
              type="text"
              value={formattedTransactionDate(data?.data?.createdAt)}
              disabled
              className="w-full h-6 px-0 py-0 text-sm bg-transparent border-none outline-none placeholder:text-sm placeholder:font-medium ring-transparent focus-visible:ring-transparent focus:border-none text-gray-dark"
            />
          </div>
        </div>
      </div>
      <Separator />
      <div className="grid grid-cols-2">
        <div className="flex flex-col gap-1">
          <h3 className="text-lg text-primary-3">
            Compliance Details{" "}
            <span
              className={cn(
                "text-xs font-medium rounded-[24px] p-2",
                data?.data?.kycStatus === "unverified"
                  ? "bg-saffron-10 text-saffron"
                  : "bg-green-0 text-green-2"
              )}
            >
              {data?.data?.kycStatus !== "unverified"
                ? "Approved"
                : "Awaiting approval"}
            </span>{" "}
          </h3>
          <p className="text-sm text-gray-80 ">
            The compliance details of this user are found here
          </p>
        </div>
        <div className="flex flex-col gap-8">
          <div className="grid grid-cols-2 gap-5">
            <div className="flex flex-col w-full items-start gap-1.5 border-[1px] rounded-[10px] px-4 py-2 h-14 border-input-border bg-off-white-1">
              <Label className="text-xs text-gray-70">
                Identity Verification Type
              </Label>
              <Input
                type="text"
                value={data?.data?.identityType}
                disabled
                className="w-full h-6 px-0 py-0 text-sm bg-transparent border-none outline-none placeholder:text-sm placeholder:font-medium ring-transparent focus-visible:ring-transparent focus:border-none text-gray-dark uppercase"
              />
            </div>
            <div className="flex flex-col w-full items-start gap-1.5 border-[1px] rounded-[10px] px-4 py-2 h-14 border-input-border bg-off-white-1">
              <Label className="text-xs text-gray-70">ID Number</Label>
              <Input
                type="text"
                value={data?.data?.identityNumber}
                disabled
                className="w-full h-6 px-0 py-0 text-sm bg-transparent border-none outline-none placeholder:text-sm placeholder:font-medium ring-transparent focus-visible:ring-transparent focus:border-none text-gray-dark"
              />
            </div>
            <div className="flex flex-col w-full items-start gap-1.5 border-[1px] rounded-[10px] px-4 py-2 h-14 border-input-border bg-off-white-1">
              <Label className="text-xs text-gray-70">Date of Birth</Label>
              <Input
                type="text"
                value={formattedTransactionDate(data?.data?.dob)}
                disabled
                className="w-full h-6 px-0 py-0 text-sm bg-transparent border-none outline-none placeholder:text-sm placeholder:font-medium ring-transparent focus-visible:ring-transparent focus:border-none text-gray-dark"
              />
            </div>
            <div className="flex flex-col w-full items-start gap-1.5 border-[1px] rounded-[10px] px-4 py-2 h-14 border-input-border bg-off-white-1">
              <Label className="text-xs text-gray-70">Gender</Label>
              <Input
                type="text"
                value={data?.data?.gender}
                disabled
                className="w-full h-6 px-0 py-0 text-sm bg-transparent border-none outline-none placeholder:text-sm placeholder:font-medium ring-transparent focus-visible:ring-transparent focus:border-none text-gray-dark capitalize"
              />
            </div>
          </div>
          <Separator />
          <div className="flex w-full gap-6 ">
            <CustomModal
              button={
                <Button
                  variant="outline"
                  className="bg-transparent border-error text-error w-full h-12 rounded-[8px]"
                >
                  <svg
                    width="18"
                    height="18"
                    viewBox="0 0 18 18"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M14.8163 11.0576L10.3105 15.5674"
                      stroke="#C70518"
                      stroke-width="1.2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <circle
                      cx="12.5625"
                      cy="13.3125"
                      r="3.1875"
                      stroke="#C70518"
                      stroke-width="1.2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M7.5 11.25H5.25C3.59315 11.25 2.25 12.5931 2.25 14.25V15"
                      stroke="#C70518"
                      stroke-width="1.2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <circle
                      cx="8.25"
                      cy="5.25"
                      r="3"
                      stroke="#C70518"
                      stroke-width="1.2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                  Reject KYC
                </Button>
              }
              size="sm"
            >
              <Reject />
            </CustomModal>
            {data?.data?.kycStatus === "unverified" && (
              <CustomModal
                button={
                  <Button className="w-full bg-gradient-to-r from-primary to-primary-2 h-12 rounded-[8px] p-[10px] ring-transparent focus-visible:ring-transparent">
                    <svg
                      width="18"
                      height="18"
                      viewBox="0 0 18 18"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <circle
                        cx="8.99938"
                        cy="6.18614"
                        r="3.18883"
                        stroke="white"
                        stroke-width="1.2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M2.99609 15.0024C2.99609 13.1379 4.50797 11.626 6.3725 11.626H8.31056"
                        stroke="white"
                        stroke-width="1.2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M14.2511 12.7048L12.0002 14.9558L10.6504 13.6052"
                        stroke="white"
                        stroke-width="1.2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                    Approve KYC
                  </Button>
                }
                size="sm"
              >
                <Approval />
              </CustomModal>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default General;
